import * as React from 'react';
import { forwardRef } from 'react';

import { InputFormGroupType, InputFormGroupProps, InputFormGroup } from '@admin/components/fields';

export const StateFormGroup = forwardRef<InputFormGroupType, InputFormGroupProps>((props, ref) => (
  <InputFormGroup type="text" id="address-state" label="State" ref={ref} {...props} />
));
